import React from "react";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExceltPatient } from "../../functions/Report.ExportPaiten";
import { formatDataPatient } from "../../utils/Report.Format";
import {
  BARCHART,
  SCREENIPAD,
  STYLEHEAD,
  STYLEBODY,
  FLEXDROPDOWN,
} from "../../../../utils/useStyle";

const ReportPatientType = ({ userDept }) => {
  const [loading, setLoading] = React.useState("");
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    type1: 0,
    type2: 0,
    type3: 0,
    type4: 0,
    type5: 0,
    type6: 0,
    type7: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getPatientTypeReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching patient type report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const total =
    data.type1 +
    data.type2 +
    data.type3 +
    data.type4 +
    data.type5 +
    data.type6 +
    data.type7;
  const type1Percentage = ((data.type1 / total) * 100).toFixed(1);
  const type2Percentage = ((data.type2 / total) * 100).toFixed(1);
  const type3Percentage = ((data.type3 / total) * 100).toFixed(1);
  const type4Percentage = ((data.type4 / total) * 100).toFixed(1);
  const type5Percentage = ((data.type5 / total) * 100).toFixed(1);
  const type6Percentage = ((data.type6 / total) * 100).toFixed(1);
  const type7Percentage = ((data.type7 / total) * 100).toFixed(1);

  const listType = [
    {
      name: `อายุรกรรม `,
      count: data?.type1,
    },
    {
      name: `ศัลยกรรม `,
      count: data?.type2,
    },
    {
      name: `สูตินรีเวช `,
      count: data?.type3,
    },
    {
      name: `กุมารเวชศาสตร์ `,
      count: data?.type4,
    },
    {
      name: `หออภิบาล `,
      count: data?.type5,
    },
    {
      name: `ผู้ป่วยนอก `,
      count: data?.type6,
    },
    {
      name: `อื่นๆ`,
      count: data?.type7,
    },
  ];

  return (
    <>
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                จำนวนผู้ป่วยตามประเภทผู้ป่วย
                <div className={STYLEBODY}>
                  แยกตามปี "{year.label} ตามประเภทสาย "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                />
                <ButtonExcel
                  onClick={() => {
                    ExceltPatient(
                      formatDataPatient(data),
                      year,
                      type,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>

            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listType}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis />
                <Tooltip />
                <Bar
                  dataKey="count"
                  fill="#fdba74"
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
            <div className="flex ml-16 ">
              <div className="mr-7">
                อายุรกรรม <br /> {type1Percentage}%
              </div>
              <div className="mr-8">
                ศัลยกรรม <br /> {type2Percentage}%
              </div>
              <div className="mr-6">
                สูตินรีเวช <br /> {type3Percentage}%{" "}
              </div>
              <div className="mr-7 text-center">
                กุมาร <br /> {type4Percentage}%<div>เวชศาสตร์</div>
              </div>
              <div className="mr-6">
                หออภิบาล <br /> {type5Percentage}%{" "}
              </div>
              <div className="mr-10">
                ผู้ป่วยนอก <br /> {type6Percentage}%{" "}
              </div>
              <div className="mr-6">
                อื่นๆ <br /> {type7Percentage}%{" "}
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportPatientType;
